module.exports = __webpack_public_path__ + "img/start_002.7d9e4840.svg";